/**
 * «MODAL OVER MODAL — ALDRI» gjort til noe som sier fra (QA-runde 12, K-7 / J1).
 *
 * ================================================================================================
 * REGELEN, ORDRETT FRA J1-TABELLEN:
 *
 *   | Modal over modal | **Aldri.** Et nytt steg åpnes inne i samme flate (panel eller steg),
 *   |                  | eller erstatter den. |
 *
 * Den ble brutt før den var skrevet: #30b, «Be om pris og tilgjengelighet» oppå artistpopupen.
 * En regel i et dokument fanger ikke den neste — den blir brutt av noen som ikke leste dokumentet,
 * i en fil langt unna, og oppdaget i neste QA-runde. Så regelen er kode her.
 *
 * ================================================================================================
 * ET REGISTER, IKKE EN REACT-KONTEKST.
 *
 * En kontekst fanger bare det som står INNE i den første dialogens undertre. Halvparten av
 * bruddene er søsken: siden holder `artistOpen` og `priceOpen` ved siden av hverandre, og begge
 * portaleres til `document.body`. Et modulregister ser begge, fordi det teller ÅPNE dialoger og
 * ikke hvor de står i treet.
 *
 * FALSK ALARM UNDER LUKKING er grunnen til at det er `open` og ikke montering som teller. Radix
 * holder en dialog montert mens utgangsanimasjonen går; hadde registeret talt monterte flater,
 * ville hver «lukk denne, åpne den neste» vært et brudd i 180 millisekunder.
 *
 * ================================================================================================
 * `console.error` OG IKKE EN KASTET FEIL. En utvikleradvarsel skal stoppe arbeidet med å bygge
 * feilen, ikke produktet for den som bruker det: en dialog som kaster ville tatt ned siden hos en
 * bruker for noe som er et designbrudd og ikke en datafeil. Den er stilnet utenfor `DEV`, og
 * `modal-nesting.test.tsx` er det som gjør den til noe en kjøring kan være rød på.
 */

/** Tittelen på hver dialog som står åpen akkurat nå, i den rekkefølgen de ble åpnet. */
const open: string[] = [];

/** Bare synlig for testen, som må starte fra ingenting selv om en forrige test lot noe stå. */
export function resetOpenModals(): void {
  open.length = 0;
}

/** Titlene som står åpne. Lesbar kopi — kallstedene skal ikke kunne skrive i registeret. */
export function openModalTitles(): readonly string[] {
  return [...open];
}

/**
 * Meld at en dialog er åpen. Returnerer opprydningen, som er ment å være en effekts `return`.
 *
 * Advarselen sier hvem som lå under, fordi «modal over modal» uten navn er en melding man ikke
 * kan finne opphavet til i en app med seksti dialoger.
 */
export function registerOpenModal(title: string): () => void {
  if (open.length > 0 && import.meta.env.DEV) {
    console.error(
      `Modal over modal: «${title}» åpnet over «${open.join('», «')}». ` +
        'J1/K-7: et nytt steg åpnes inne i samme flate, eller erstatter den. ' +
        'Bruk et steg eller et panel i dialogen som alt står åpen.',
    );
  }
  open.push(title);

  return () => {
    const index = open.lastIndexOf(title);
    if (index !== -1) open.splice(index, 1);
  };
}
